module.exports = __webpack_public_path__ + "static/media/5.13_preview.3deb5d27.png";